import { ProductBrand, productBrandFromResponse } from './ProductBrand';
import { ProductImage, productImageFromResponse } from './ProductImage';
import {
  ProductPriceInfo,
  productPriceInfoFromResponse,
} from './ProductPriceInfo';
import {
  ProductCategory,
  productCategoryFromResponse,
} from './ProductCategory';
import { ProductOption, productOptionFromResponse } from './ProductOption';
import { Tag, tagFromResponse } from '../Tag/Tag';
import { OfferSummary, offerSummaryFromResponse } from '../Offer/OfferSummary';
import { Meta, metaFromResponse } from '../Meta/Meta';

export interface Product {
  id: number;
  isVirtual: boolean;
  productOrder: number;
  slug: string;
  name: string;
  meta: Meta;
  barcode?: string;
  sku?: string;
  qty: number;
  skt?: string;
  viewed: number;
  brand: ProductBrand;
  baseImage: ProductImage;
  price: ProductPriceInfo;
  specialPrice?: ProductPriceInfo;
  shortDescription: string;
  description: string;
  videoUrl?: string;
  files: ProductImage[];
  categories: ProductCategory[];
  options: ProductOption[];
  offers: OfferSummary[];
  tags: Tag[];
  attributes: string[];
}

export const productFromResponse = (responseData: any): Product => ({
  id: responseData.id,
  isVirtual: responseData.is_virtual,
  productOrder: responseData.product_order,
  slug: responseData.slug,
  name: responseData.name,
  meta: metaFromResponse(responseData.meta),
  barcode: responseData.barcode,
  sku: responseData.sku,
  qty: responseData.qty,
  skt: responseData.skt,
  viewed: responseData.viewed,
  brand: productBrandFromResponse(responseData.brand),
  baseImage: productImageFromResponse(responseData.base_image),
  price: productPriceInfoFromResponse(responseData.price),
  specialPrice: responseData.special_price
    ? productPriceInfoFromResponse(responseData.special_price)
    : undefined,
  shortDescription: responseData.short_description,
  description: responseData.description,
  videoUrl: responseData.video_url,
  files: responseData.files.map(productImageFromResponse),
  categories: responseData.categories.map(productCategoryFromResponse),
  options: responseData.options.map(productOptionFromResponse),
  offers: responseData.offers.map(offerSummaryFromResponse),
  tags: responseData.tags.map(tagFromResponse),
  attributes: responseData.attributes ?? [],
});
